var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29126 9.18747L9.54139 10.3037L10.9999 9.00144L12.4584 7.69922",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8755 19.9996H5.62433C5.45856 19.9996 5.29957 19.9338 5.18235 19.8165C5.06512 19.6993 4.99927 19.5403 4.99927 19.3745V5.62311C4.99927 5.45733 5.06512 5.29835 5.18235 5.18112C5.29957 5.0639 5.45856 4.99805 5.62433 4.99805L16.7192 4.99805C17.1508 4.99805 17.5006 5.34786 17.5006 5.77938V19.3745C17.5006 19.5403 17.4347 19.6993 17.3175 19.8165C17.2003 19.9338 17.0413 19.9996 16.8755 19.9996Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5H14.1674",
    stroke: "#666666",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50049 16.668H15.0013",
    stroke: "#666666",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyIcon);
export default __webpack_public_path__ + "static/media/policy-icon.7693b7db63ad42b0bbf38c45b40863c0.svg";
export { ForwardRef as ReactComponent };